<template>
  <v-sheet class="mx-4 mb-2 grey lighten-3" rounded>
    <v-row no-gutters align="start">
      <v-col cols="12" md="auto">
        <div class="ma-4">
          <div class="font-weight-black">{{ thg.year }}</div>
          <div class="text-caption">{{ $t("components.thg.ThgMyVehicleThgQuoteDetail.thgPremium") }}</div>
        </div>
      </v-col>

      <v-col cols="12" md="auto">
        <div class="ma-4">
          <div>
            <v-icon left :color="thgStatus.color">mdi-check-circle</v-icon>
            {{ $t(thgStatus.textAlt) }}
          </div>
          <div class="text-caption" @click="showDetailInfos" v-if="historyEnabled">
            <span v-if="!showInfos">
              {{ $t("components.thg.ThgMyVehicleThgQuoteDetail.showMoreInfo") }}
              <v-icon left x-small>mdi-chevron-down</v-icon>
            </span>
            <span v-else>
              {{ $t("components.thg.ThgMyVehicleThgQuoteDetail.showLessInfo") }}
              <v-icon left x-small>mdi-chevron-up</v-icon>
            </span>
          </div>
          <v-stepper v-if="showInfos" vertical v-model="step" elevation="0" class="mt-4">
            <v-stepper-step step="1">
              {{ $t("components.thg.ThgMyVehicleThgQuoteDetail.step1Main", { year: thg.year }) }}
              <small>{{ $t("components.thg.ThgMyVehicleThgQuoteDetail.step1Small") }}</small>
            </v-stepper-step>
            <v-stepper-content step="1">
              <v-card elevation="0" class="mb-12">
                {{ $t("components.thg.ThgMyVehicleThgQuoteDetail.step1Card") }}<br />
                {{ thg.id }}
              </v-card>
              <v-btn color="primary">
                {{ $t("components.thg.ThgMyVehicleThgQuoteDetail.uploadVehicleCertificate") }}
              </v-btn>
              <v-btn text>
                {{ $t("components.thg.ThgMyVehicleThgQuoteDetail.inquiries") }}
              </v-btn>
            </v-stepper-content>

            <v-stepper-step step="2">
              {{ $t("components.thg.ThgMyVehicleThgQuoteDetail.step2") }}
            </v-stepper-step>
            <v-stepper-content step="2"></v-stepper-content>

            <v-stepper-step step="3">
              {{ $t("components.thg.ThgMyVehicleThgQuoteDetail.step3Main") }}
              <small>{{ $t("components.thg.ThgMyVehicleThgQuoteDetail.step3Small") }}</small>
            </v-stepper-step>
            <v-stepper-content step="3"></v-stepper-content>

            <v-stepper-step step="4">
              {{ $t("components.thg.ThgMyVehicleThgQuoteDetail.step4") }}
            </v-stepper-step>
            <v-stepper-content step="4"></v-stepper-content>

            <v-stepper-step step="5">
              {{ $t("components.thg.ThgMyVehicleThgQuoteDetail.step5") }}
            </v-stepper-step>
            <v-stepper-content step="5"></v-stepper-content>
          </v-stepper>
        </div>
      </v-col>

      <v-col v-if="priceEnabled" cols="12" md="auto" class="d-md-flex ml-auto">
        <div class="ma-4 text-right">
          <div class="font-weight-black">
            {{ price.priceAndPromotionAsString }}
          </div>
          <div v-if="thg.promotionConfiguration && price.price" class="text-caption green--text text--darken-4">
            {{
              $t("components.thg.ThgMyVehicleThgQuoteDetail.promotionBonus", {
                bonusValue: thg.promotionConfiguration.value
              })
            }}
          </div>
        </div>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script lang="ts">
import { IThgStatus } from "@/lib/interfaces/thg/thg-status.interface";
import { ThgPriceHelper } from "@/lib/thg/thgPriceHelper";
import { getThgStatusOrDefault } from "@/lib/utility/thgStatusMap";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { ThgThgMeViewModelGen } from "@/services/thg/v1/data-contracts";
import { Component, Prop } from "vue-property-decorator";
import ThgQuoteVehicleUpdateRegistrationDialog from "./ThgQuoteVehicleUpdateRegistrationDialog.vue";

@Component({
  components: {
    ThgQuoteVehicleUpdateRegistrationDialog
  }
})
export default class ThgMyVehicleThgQuoteDetail extends DarkModeHighlightMixin {
  @Prop()
  thg!: ThgThgMeViewModelGen;

  historyEnabled = false;
  priceEnabled = true;

  showInfos = false;
  showDetailInfos() {
    this.showInfos = !this.showInfos;
  }

  step = 1;

  get price() {
    return new ThgPriceHelper(this.thg);
  }

  get thgStatus(): IThgStatus {
    return getThgStatusOrDefault(this.thg.status);
  }
}
</script>
